import * as React from 'react';
import Grid from '@mui/system/Grid';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Paper from '@mui/material/Paper';
import { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/system/Grid": Grid, "@mui/material/FormLabel": FormLabel, "@mui/material/FormControl": FormControl, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio, "@mui/material/Paper": Paper, "@mui/internal-core-docs/HighlightedCode": { HighlightedCode } } } });
export default ClientProvider;
